import { useLocation } from "react-router-dom";

const usePageIndex = () => {
  const { search, state } = useLocation();
  const pageIndex = search.replace("?pageindex=", "");
  return { pageIndex, state };
};

export default usePageIndex;
